import request from '@/utils/request'

export interface Token {
  uid: string
  name: string
  expired: Date
  roles: string
}

export function FindToken(): Promise<Token[]> {
  return request.get('/token')
}

export function GenerateToken(
  name: string,
  expired: Date,
  roles: string
): Promise<string> {
  return request.post('/token', { name, expired, roles })
}

export function Regenerate(uid: string): Promise<string> {
  return request.patch(`/token/${uid}`)
}

export function RevokeToken(uid: string) {
  return request.delete(`/token/${uid}`)
}
